import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { importModel } from './importModel';
import { Card, Input, Tooltip } from 'reactstrap';
import { usePermissions } from 'Components/Hooks/usePermissions';


const Model = (props: any) => {
    const [selectedCard, setselectedCrad] = useState<any>("");
    const { setImportJson, importJson, setModal, modal } = props;
    const { checkModulePermission } = usePermissions();
    const [errorTooltip, setErrorTooltip]: any = useState("");

    useEffect(() => {
        setselectedCrad(modal)
    }, [modal])


    const handleperm = (action: any, modal: any, skipperm: any) => {
        let perm: any = checkModulePermission(
            modal,
            action,
            skipperm
        );
        if (perm?.allowed) return true
        else return false
    }

    return (
        <React.Fragment>
            <div className='vstack justify-content-center gap-3'>
                <h3 className='text-center'>What kind of data is in your file?</h3>
                <div className='hstack justify-content-center gap-3'>
                    {
                        importModel && importModel.length ? importModel.map((item: any) => {
                            let isAccess = handleperm('Import', item?.model, false);
                            return <div>
                                <div
                                    id={`${item?.model}TooltipButton`}
                                    onMouseEnter={() => !isAccess && setErrorTooltip(item?.model)}
                                    onMouseLeave={() => setErrorTooltip(false)}
                                    style={{opacity:!isAccess? 0.5 : 1}}
                                    >
                                    <Card className={item.model === selectedCard ? `p-4 border  border-3 border-primary bg-primary-subtle bg-opacity-10 gap-2` : `p-4 border border-1 border-primary border-opacity-25 gap-2 ${!isAccess ? 'text-opacity-25' : ''}`} style={{ width: 180, height: 250, cursor: !isAccess ? 'not-allowed' : 'pointer' }} onClick={isAccess ? () => { setselectedCrad(item.model); setModal(item.model); setImportJson({ ...importJson, model: item.model }) } : () => { }}>
                                        <div className='hstack justify-content-end'>
                                            <Input disabled={!isAccess} title={isAccess ? "" : "You do not have the required permissions. Please contact your administrator."} type='checkbox' checked={item.model === selectedCard} />
                                        </div>
                                        <div className={`align-self-center ${!isAccess ? 'text-muted':''}`}>
                                            <i className={`${item.svg} fs-24 text-primary`}></i>
                                        </div>
                                        <div className='vstack gap-2'>
                                            <h5 className={`text-center ${!isAccess ? 'text-muted':''}`}>{item.title}</h5>
                                        </div>
                                        <p className={`fs-14 text-center ${!isAccess ? 'text-muted':''}`}>
                                            {item.description}
                                        </p>
                                    </Card>
                                    </div>
                                        {!isAccess && errorTooltip === item?.model && ( // Show Tooltip only if condition is true
                                            <Tooltip
                                                isOpen={errorTooltip}
                                                target={`${item?.model}TooltipButton`}
                                            >
                                                You do not have the required permissions. Please contact your administrator.
                                            </Tooltip>
                                        )}
                                    </div>
                        }) : null
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default withTranslation()(Model);
